












































import {Component, Prop, Vue} from 'vue-property-decorator'
import CardCommon from '@/components/cards/CardCommon.vue'
import IconCustom from '@/components/lib/IconCustom.vue'
import ServicePrice from '@/components/ServicePrice.vue'
import ButtonCommon from '@/components/lib/ButtonCommon.vue'
import {
  Category,
  ISolution,
  CategoryArray,
  ServiceTypePrice,
  IServiceTypePrice,
  IService
} from '@/entities'
import {newLines} from '@/lib'
import {ILink} from '@/components/lib/models'

@Component({
  components: {
    CardCommon,
    IconCustom,
    ServicePrice,
    ButtonCommon
  }
})
export default class SolutionCard extends Vue {

  @Prop() readonly data!: ISolution

  get titleHtml(): string {
    return newLines(this.data.name);
  }

  get services(): IService[] {
    return this.data.service.sort((a: IService, b: IService) => {
      return b.service_type_priced.price - a.service_type_priced.price;
    });
  }

  get serviceLabels(): string[] {
    return this.services.map((service: IService) => {
      let item = service.service_type_priced.service_type;
      return item.type === 'consultation' ? this.$tc('services.solutions.consultation', service.limit) : item.name;
    });
  }

  get categoryLevel(): number | undefined {
    let i = undefined;
    CategoryArray.forEach((category: Category, index: number) => {
      if (category === this.data.category) {
        i = index + 1;
      }
    });
    return i;
  }

  get categoryColor(): string | undefined {
    let level = this.categoryLevel;
    return level ? ['bronze', 'silver', 'gold'][level - 1] : undefined;
  }

  get readiness(): string[] {
    let ready = this.data.readiness_days;
    return ready ? [
      this.$t('services.solutions.ready') as string,
      this.$t('lim-to') + ' ' + ready + ' ' + this.$tc('working-days', ready)
    ] : [];
  }

  get price(): IServiceTypePrice {
    return new ServiceTypePrice({
      price: this.data.total,
      category: this.data.category
    });
  }

  get link(): ILink {
    return {
      label: this.$t('links.service') as string,
      ref: 'ModalSolution'
    }
  }

  private getSolution(): void {
    this.$storage.actions.setModal({
      name: 'ModalSolution',
      subject: this.data,
      from: 'services'
    })
  }

}
